import { Button } from '../ui';

/** "Load more" under a cursor list; hidden once the server has no older rows. */
export function LoadMore({ q }: { q: { hasNextPage: boolean; isFetchingNextPage: boolean; fetchNextPage: () => unknown; rows: readonly unknown[] } }) {
  if (!q.hasNextPage) return q.rows.length ? <div className="loadMore faint small">已顯示全部 {q.rows.length} 項</div> : null;
  return (
    <div className="loadMore">
      <Button size="sm" busy={q.isFetchingNextPage} onClick={() => void q.fetchNextPage()}>
        載入更多（已顯示 {q.rows.length} 項）
      </Button>
    </div>
  );
}
